module.exports = __webpack_public_path__ + "img/chess-rook.66c81bb7.svg";